const ko = {
  ID_RECOMMEND: "Recommend",
  ID_RECENT: "Recent",
  ID_ASSET_TYPE_MODEL: "Asset",
  ID_ASSET_TYPE_MESH: "Mesh",
  ID_ASSET_TYPE_GUI: "GUI",
  ID_ASSET_TYPE_VIDEO: "Video",
  ID_ASSET_TYPE_SOUND: "Sound",
  ID_ASSET_TYPE_LIGHT: "Light",
  ID_ASSET_TYPE_EFFECT: "Effect",
  ID_ASSET_TYPE_SPAWN: "Spawn",
  ID_ASSET_TYPE_AD: "Ad Asset",

  ID_LIST_MORE_BUTTON: "더보기",

  ID_ASSET_GENRE_ALL: "전체",
  ID_ASSET_GENRE_BUILDING: "Building",
  ID_ASSET_GENRE_DECORATION: "Decoration",
  ID_ASSET_GENRE_FOODS: "Foods",
  ID_ASSET_GENRE_FURNITURE: "Furniture",
  ID_ASSET_GENRE_MACHINE: "Machine",
  ID_ASSET_GENRE_NATURE: "Nature",
  ID_ASSET_GENRE_STRUCTURE: "Structure",
  ID_ASSET_GENRE_VEHICLE: "Vehicle",
  ID_ASSET_GENRE_GROUND: "Ground",

  ID_SAVE_AS_ASSET_POPUP_TITLE: "Save as Asset",
  ID_ASSET_PROPERTIES_POPUP_TITLE: "Asset Properties",

  ID_CATEGORY_NAME: "Name",
  ID_CATEGORY_PUBLIC: "Public",
  ID_CATEGORY_GENRE: "Genre",
  ID_CATEGORY_KEYWORD: "Keyword",

  ID_ASSET_NAME_INPUT_PLACEHOLDER: "에셋 이름을 입력해주세요",
  ID_GENRE_PLACEHOLDER: "장르를 선택해주세요",
  ID_KEYWORD_PLACEHOLDER: "키워드를 띄어쓰기 없이 입력하고, 엔터를 누르면 입력됩니다.",

  ID_SEARCH_PLACEHOLDER: "검색어를 입력하세요",

  ID_ACTION_CANCEL: "취소",
  ID_ACTION_SAVE: "저장",
  ID_MYASSET_CATEGORY_ASSET: "Asset",
  ID_MYASSET_CATEGORY_NFT: "NFT",

  ID_MYASSET_TYPE_3D_ASSET: "3D Asset",
  ID_MYASSET_TYPE_MODEL: "Model",
  ID_MYASSET_TYPE_IMAGE: "Image",

  ID_ASSET_FILE_UPLOAD: "파일 업로드",

  ID_MYASSET_BOTTOM_TERMS:
    "고객님이 업로드하는 콘텐츠가 레드브릭의 {white}을 준수하며,\n제 3자의 어떠한 권리도 침해하고 있지 않음을 확인합니다.",
  ID_MYASSET_BOTTOM_TERMS_WHITE: "이용약관",
  ID_MYASSET_BOTTOM_SELECT_BUTTON: "선택",

  ID_DRAG_DIMMED_TITLE: "끌어와서 파일 업로드",
  ID_DRAG_DIMMED_HELP_TEXT: "gltf, glb, png, jpg, jpeg, mov, mp4, mpeg, mp3, wav\n형식의 파일을 한 번에 여러 개 업로드할 수 있습니다.",
  ID_ASSET_NOT_SUPPORTED: "지원하지 않는 형식의 파일입니다.",
  ID_PUBLIC_TITLE: "공개",
  ID_GENRE_TITLE: "장르",
  ID_DOWNLOAD_TITLE: "다운로드",
  ID_ADD_TO_GUI: "GUI로 추가",
  ID_SELECT_CATEGORY: "항목 선택",
  ID_DELETE_TITLE: "삭제",
  ID_SEARCH_CATEGORY_LATELY: "최근 검색",
  ID_SEARCH_CATEGORY_RECOMMENDATION: "추천 검색",
  ID_FAVORITE_ASSET: "즐겨찾기",

  ID_DELETE_ITEM_SELECT_LENGTH: "개 선택",
  ID_SEARCH_WORD_RESULT: "검색 결과",
  ID_NO_ASSETS: "표시할 에셋이 없습니다.",
  ID_NO_KEYWORDS: "keyword가 없습니다.",

  ID_ERROR_SAVE_ASSET: "에셋 정보 저장에 실패했습니다.",
  ID_ERROR_S3_UPLOAD: "에셋 업로드에 실패했습니다.",
  ID_ERROR_IMPORT_ASSET: "에셋 포맷 변환에 실패했습니다.",

  ID_NO_RECENT_ASSET: "최근에 사용한 에셋이 없습니다.",
};

export default ko;
